import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as IconFacebook } from '../../media/icons/social_facebook.svg';
import { ReactComponent as IconInstagram } from '../../media/icons/social_instagram.svg';
import { ReactComponent as IconLinkedin } from '../../media/icons/social_linkedin.svg';

export default class Footer extends Component {
    render() {
        return (
            <div className="footer">
                <div className="footer__background">
                    <div className="footer__background__top"></div>
                </div>
                <div className="footer-wrapper">

                    <div className="footer__column">
                        <div className="footer__column__element footer__column__title text-bold text-subtitle">
                            About
                        </div>
                        <div className="footer__column__element text-box text-justify">
                            Guidr helps travelers discover and plan unforgettable trips with expert-curated itineraries. Whether you're looking for hidden gems, adventure-packed journeys, or foodie escapes, find the perfect itinerary crafted by locals and travel experts. Start exploring today!
                        </div>
                    </div>

                    <div className="footer__column">
                        <div className="footer__column__element footer__column__title text-bold text-subtitle">
                            Explore locations
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?category=Beach" className="link-color-light">
                                Sunny beach trips
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?size=Couple" className="link-color-light">
                                Romantic couple trips
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?category=Roadtrip" className="link-color-light">
                                Relaxing roadtrips
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?category=Nature" className="link-color-light">
                                Nature escapes
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?category=City%20trip" className="link-color-light">
                                Historic city trips
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?category=Party" className="link-color-light">
                                Glamorous party trips
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?category=Cultural" className="link-color-light">
                                Authentic cultural experiences
                            </Link>
                        </div>
                    </div>

                    <div className="footer__column">
                        <div className="footer__column__element footer__column__title text-bold text-subtitle">
                            Learn more
                        </div>
                        <div className="footer__column__element">
                            <Link to="/travelers" className="link-color-light">
                                For travelers and trip planners
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/creators" className="link-color-light">
                                For travel experts and trip creators
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/signup" className="link-color-light">
                                Sign up
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/login" className="link-color-light">
                                Log in
                            </Link>
                        </div>
                    </div>

                    <div className="footer__column footer__column--wide">
                        <div className="footer__column__element">
                            <div className="footer__social-container">
                                <Link to={""} className="footer__social__logo">
                                    <IconFacebook className="footer__social__logo-inner" />
                                </Link>
                                <Link to={""} className="footer__social__logo">
                                    <IconInstagram className="footer__social__logo-inner" />
                                </Link>
                                <Link to={""} className="footer__social__logo">
                                    <IconLinkedin className="footer__social__logo-inner" />
                                </Link>
                                <Link to={""} className="footer__social__logo">
                                    <IconFacebook className="footer__social__logo-inner" />
                                </Link>
                            </div>
                        </div>
                        <div className="footer__column__element">
                            <div className="footer__copyright">
                                © 2025 Guidr. All rights reserved worldwide.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}
